import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { AlertService } from '@app/alert/service/alert.service'
import { UserContextService } from '@core/service/user-context.service'

@Injectable({
  providedIn: 'root',
})
export class SecuredService implements CanActivate {
  constructor(private router: Router, private userContext: UserContextService, private alertService: AlertService) {}
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (!route?.data?.roles || !Array.isArray(route.data.roles)) {
      throw new Error('Expecting data roles[]: ' + route.routeConfig.path)
    }

    if (!this.userContext.hasAnyRole(route.data.roles)) {
      this.userContext.destroy()
      this.alertService.showError('Você não tem permissão para realizar essa ação', 'Acesso negado')
      this.router.navigateByUrl('/login')
      return false
    }
    return true
  }
}
